<template>
  <div>
    <div class="md-layout-item md-small-size-100">
      <md-field :class="getValidationClass('intervalo')">
        <label :for="`intervalo${_uid}`"> Intervalo de envio (minutos) </label>
        <md-input
          v-model.number="form.intervalo"
          type="number"
          name="intervalo"
          :for="`intervalo${_uid}`"
          @input="() => handleChange()"
        />
        <span v-if="$v.form.intervalo.required" class="md-error"
          >Campo Obrigatório</span
        >
        <span v-if="$v.form.intervalo.minValue" class="md-error">
          Valor deve ser maior que zero
        </span>
      </md-field>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import equipamentoMixin from '@/mixins/equipamento.mixin'

export default {
  name: 'FinalRedeEquipamentoConfig',
  mixins: [validationMixin, equipamentoMixin],
  props: {
    config: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: {
        intervalo: 5,
      },
    }
  },
  validations: {
    form: {
      intervalo: {
        required,
        minValue: (value) => value > 0,
      },
    },
  },
  beforeMount() {
    this.form.intervalo = this.getConfigValue(
      this.config,
      'IntervaloFinalRedeConfig',
      'intervalo',
      5
    )

    this.handleChange()
  },
  methods: {
    handleChange() {
      this.$v.$touch()

      this.$emit('change', {
        form: {
          IntervaloFinalRedeConfig: {
            intervalo: this.form.intervalo,
          },
        },
        valid: this.$v.$valid,
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
